var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "1rem" } },
    [
      _c("topbar", { attrs: { text: "我的电子书" } }),
      _vm._v(" "),
      !_vm.emptyStatus
        ? _c(
            "ul",
            { staticClass: "scaleList" },
            [
              _vm._l(_vm.bookList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    on: {
                      click: function($event) {
                        _vm.selectScale(item.bookId, item.orderNo)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "scaleRight",
                      style: {
                        background:
                          "url(" +
                          _vm.EnvUrl +
                          item.bookPic +
                          ") no-repeat center/cover"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "scaleLeft" }, [
                      _c("div", { staticClass: "scaleTitle" }, [
                        _vm._v(_vm._s(item.title))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "scaleContent" }, [
                        _vm._v(_vm._s(item.tagline))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "scaleBottom" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("time")(item.createTime)) +
                            "\n                "
                        )
                      ])
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c("no-more-data", { attrs: { noMoreData: _vm.noMoreData } })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emptyStatus
        ? _c("div", { staticClass: "emptyBox" }, [
            _c("div", { staticClass: "emptyImg" }),
            _vm._v(" "),
            _c("div", { staticClass: "emptyName" }, [
              _vm._v("您还没有电子书哦~")
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff59e87c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff59e87c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/myEBook.vue
// module id = null
// module chunks = 